import { render } from "./CourseDescription.vue?vue&type=template&id=41f6de64&scoped=true"
import script from "./CourseDescription.vue?vue&type=script&lang=js"
export * from "./CourseDescription.vue?vue&type=script&lang=js"

import "./CourseDescription.vue?vue&type=style&index=0&id=41f6de64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f6de64"]])

export default __exports__